<template>
  <div v-if="event">
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Configurações</h2>
        </b-col>
      </b-row>
      <b-row class="my-2">
        <b-col>
          <b-alert show variant="info" class="mb-0 py-2">
            Para configurar o modo de impressão, acesse Configurações de {{ gui ? gui.dealersLC : 'revendedores' }}.
          </b-alert>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col cols="12" md="6">
          <b-form-group label="Omitir impressão da logo:">
            <toggle-button
              :value="event.omit_logo === 1"
              :sync="true"
              :width="45"
              :height="25"
              :color="{ checked: '#337ab7', unchecked: '#cccccc' }"
              @change="toggleOmitLogo"
            />
            <small class="form-text text-muted">
              Quando ativado, a logo do evento não é baixada nem impressa no ingresso.
              Útil para cenários de rede congestionada, pois auxilia na redução do tráfego de dados.
            </small>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="12" md="6">
          <b-form-group label="Habilitar categorias?">
            <toggle-button
              :value="event.categories_enabled === 1"
              :sync="true"
              :width="45"
              :height="25"
              :color="{ checked: '#337ab7', unchecked: '#cccccc' }"
              @change="toggleCategoriesEnabled"
            />
            <small class="form-text text-muted">
              Quando ativado, o organizador pode criar categorias e associá-las aos itens/lotes do evento.
            </small>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="12" md="6">
          <b-form-group label="Numeração aleatória?">
            <toggle-button
              :value="event.random_number_enabled === 1"
              :sync="true"
              :width="45"
              :height="25"
              :disabled="event.random_number_locked === 1"
              :color="{ checked: '#337ab7', unchecked: '#cccccc' }"
              @change="toggleRandomNumberEnabled"
            />
            <small class="form-text text-muted" v-if="event.random_number_locked === 1">
              A numeração desta operação já está definida e não pode mais ser alterada, pois ela já emitiu
              {{ gui ? gui.tickets.toLowerCase() : 'ingressos' }}. Para escolher de forma diferente, crie uma
              nova operação (ou clone esta).
            </small>
            <small class="form-text text-muted" v-else>
              Quando ativado, os números dos {{ gui ? gui.tickets.toLowerCase() : 'ingressos' }} deixam de ser
              sequenciais, o que evita que se descubra o volume de vendas pelo número. Só pode ser definido
              antes da primeira emissão, e não pode mais ser alterado depois.
            </small>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="12" md="6">
          <b-form-group label="Mesa?">
            <toggle-button
              :value="event.table_map_notice_enabled === 1"
              :sync="true"
              :width="45"
              :height="25"
              :color="{ checked: '#337ab7', unchecked: '#cccccc' }"
              @change="toggleTableMapNotice"
            />
            <small class="form-text text-muted">
              Ativa o aviso para o cliente ver o mapa das mesas antes de comprar.
            </small>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ToggleButton from 'vue-js-toggle-button/src/Button'
import Gui from '@/gui'

export default {
  name: 'AdminConfig',
  components: {
    ToggleButton
  },
  data () {
    return {
      event: null
    }
  },
  computed: {
    gui () {
      if (!this.event) return null
      return new Gui(this.event.show_qrcode ? 'evento' : 'ficha')
    }
  },
  async mounted () {
    await this.getEvent()
  },
  methods: {
    async getEvent () {
      try {
        const eventId = this.$route.params.id
        const url = process.env.VUE_APP_URL_APP + `/b/events/${eventId}`
        const resp = await this.$http.get(url)
        this.event = resp.body
      } catch (error) {
        console.error(error)
      }
    },
    async toggleOmitLogo () {
      const url = process.env.VUE_APP_URL_APP + `/b/events/${this.event.id}/omit-logo/toggle`
      try {
        await this.$http.put(url)
        this.event.omit_logo = this.event.omit_logo === 1 ? 0 : 1
      } catch (err) {
        alert(err.body.message)
        console.error(err)
      }
    },
    async toggleCategoriesEnabled () {
      const url = process.env.VUE_APP_URL_APP + `/b/events/${this.event.id}/categories/toggle`
      try {
        await this.$http.put(url)
        this.event.categories_enabled = this.event.categories_enabled === 1 ? 0 : 1
      } catch (err) {
        alert(err.body.message)
        console.error(err)
      }
    },
    async toggleRandomNumberEnabled () {
      const url = process.env.VUE_APP_URL_APP + `/b/events/${this.event.id}/random-number/toggle`
      try {
        await this.$http.put(url)
        this.event.random_number_enabled = this.event.random_number_enabled === 1 ? 0 : 1
      } catch (err) {
        alert(err.body.message)
        console.error(err)
      }
    },
    async toggleTableMapNotice () {
      const url = process.env.VUE_APP_URL_APP + `/b/events/${this.event.id}/table-map-notice/toggle`
      try {
        await this.$http.put(url)
        this.event.table_map_notice_enabled = this.event.table_map_notice_enabled === 1 ? 0 : 1
      } catch (err) {
        alert(err.body.message)
        console.error(err)
      }
    }
  }
}
</script>
